import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { CardSkeleton } from './components/CardSkeleton';
import { CardWithAvatarSkeleton } from './components/CardWithAvatarSkeleton';
import { ModalSkeleton } from './components/ModalSkeleton';
import { SkeletonLoaderComponent } from './components/SkeletonLoaderComponent';
export var SkeletonLoader = forwardRef((props, ref) => {
  var type = props.type;
  if (type == 'modal') return _jsx(ModalSkeleton, Object.assign({}, props));
  if (type == 'card') return _jsx(CardSkeleton, Object.assign({}, props));
  if (type == 'card-with-avatar') return _jsx(CardWithAvatarSkeleton, Object.assign({}, props));
  return _jsx(SkeletonLoaderComponent, Object.assign({}, props, {
    ref: ref
  }));
});